export enum ButtonLinkTypeEnum {
  openInSameWindow = '_self',
  openInNewWindow = '_blank',
}

export const buttonLinkTypeNames: Record<ButtonLinkTypeEnum, string> = {
  [ButtonLinkTypeEnum.openInSameWindow]: 'Open in same window',
  [ButtonLinkTypeEnum.openInNewWindow]: 'Open in new window',
}
